var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"text-white px-5"},[_vm._v("Copyright © 2022 Xxxxxxxxxxx All Rights Reserved.")])])])
}]

export { render, staticRenderFns }